import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import SvgIcon from "../parts/SvgIcon";

function SignupPasswordView({ onBack, handleSignupPwd, handleFieldChange }) {
  const { t } = useTranslation("auth");
  const [passwordType, setPasswordType] = React.useState("password");
  const [confirmPasswordType, setConfirmPasswordType] =
    React.useState("password");

  React.useEffect(() => {
    document.querySelector('input[name="passwordSignup"]')?.focus();
  }, []);

  const changePasswordType = (e, input) => {
    e.preventDefault();
    if (input === "password") {
      setPasswordType((prev) => (prev === "password" ? "text" : "password"));
    } else {
      setConfirmPasswordType((prev) =>
        prev === "password" ? "text" : "password"
      );
    }
  };

  return (
    <LoginWrapper
      mainClass="Onboarding athlete"
      left={
        <form method="POST" data-noreset onSubmit={handleSignupPwd}>
          <BackArrowButton onBack={(_) => onBack(0)} />
          <div>
            <h1>{t("signupPassword.title")}</h1>
          </div>

          <div className="input-password-wrapper">
            <label htmlFor="password">{t("signupPassword.passwordLabel")}</label>
            <input
              type={passwordType}
              name="passwordSignup"
              required
              onChange={handleFieldChange}
              placeholder={t("signupPassword.placeholder")}
              sz="large"
            />
            <button
              data-button-type="text-white"
              data-icon-only=""
              onClick={(e) => changePasswordType(e, "password")}
              tabIndex="-1"
              type="button"
            >
              <SvgIcon
                src={
                  passwordType === "password"
                    ? "/img/new-icons/eye.svg"
                    : "/img/new-icons/eye-slash.svg"
                }
                alt={t("signupPassword.eyeAlt")}
              />
            </button>
          </div>
          <div className="input-password-wrapper">
            <label htmlFor="password">
              {t("signupPassword.confirmPasswordLabel")}
            </label>
            <input
              type={confirmPasswordType}
              name="confirmPasswordSignup"
              required
              onChange={handleFieldChange}
              placeholder={t("signupPassword.placeholder")}
              sz="large"
            />
            <button
              data-button-type="text-white"
              data-icon-only=""
              onClick={(e) => changePasswordType(e, "confirm-password")}
              tabIndex="-1"
              type="button"
            >
              <SvgIcon
                src={
                  confirmPasswordType === "password"
                    ? "/img/new-icons/eye.svg"
                    : "/img/new-icons/eye-slash.svg"
                }
                alt={t("signupPassword.eyeAlt")}
              />
            </button>
          </div>

          <div className="chip info mt-2">
            {t("signupPassword.passwordMinLength")}
          </div>

          <button
            data-button-type="primary"
            sz="large"
            onClick={handleSignupPwd}
          >
            {t("signupPassword.continue")}
          </button>
        </form>
      }
    />
  );
}

export default SignupPasswordView;
